/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    INFO_BANNER_SET_BANNER_TIP_VISIBLITY,
    SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE,
    SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX,
    SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT,
    SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM,
    SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE,
    SET_ACTIONS_STRIP_HIGHLIGHT_INDEX,
    SET_ENTERED_CHANNEL_NUMBER,
    SET_ENTERTING_CHANNEL_NUMBER_ENABLED,
    SET_IS_ACTIONS_STRIP_ACTIVE,
    SET_IS_FULL_INFO_ACTIVE,
    SET_IS_STANDARD_INFO_ACTIVE,
    SET_IS_TRICKPLAY_MENU_ACTIVE,
    SET_MEDIA_BUTTON_MOUSE_OVER_INDEX,
    UPDATE_ACTION_STRIP_REFERECE,
    UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER,
    UPDATE_FULL_INFO_TIMER,
    UPDATE_STANDARD_INFO_TIMER,
    UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID,
    UPDATE_TRICKPLAY_TIMER,
} from './infobanner.types';
import { MediaButtonState, MediaButtonTypes } from './mediabuttontypes';

export const infoBannerSetBannerTipVisibilityAction = (
    isBannerTipVisible: boolean,
): TivoPayloadAction<{ isBannerTipVisible: boolean }> => ({
    type: INFO_BANNER_SET_BANNER_TIP_VISIBLITY,
    payload: {
        isBannerTipVisible,
    },
});

export const setActionsStripHighlightIndexAction = (
    actionsStripHighlightIndex: number,
): TivoPayloadAction<{ actionsStripHighlightIndex: number }> => ({
    type: SET_ACTIONS_STRIP_HIGHLIGHT_INDEX,
    payload: {
        actionsStripHighlightIndex,
    },
});

export const setActionsStripHighlightBorderActiveAction = (
    actionsStripHighlightBorderActive: boolean,
): TivoPayloadAction<{ actionsStripHighlightBorderActive: boolean }> => ({
    type: SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE,
    payload: {
        actionsStripHighlightBorderActive,
    },
});

export const setAvailableActionItemsAction = (
    availableActionItems: Array<any>,
): TivoPayloadAction<{ availableActionItems: Array<any> }> => ({
    type: SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM,
    payload: {
        availableActionItems,
    },
});

export const setActionItemsCountAction = (
    actionItemsCount: number,
): TivoPayloadAction<{ actionItemsCount: number }> => ({
    type: SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT,
    payload: {
        actionItemsCount,
    },
});

export const setIsActionsStripActive = (
    isActionsStripActive: boolean,
): TivoPayloadAction<{ isActionsStripActive: boolean }> => ({
    type: SET_IS_ACTIONS_STRIP_ACTIVE,
    payload: { isActionsStripActive },
});

export const setIsStandardInfoActive = (
    isStandardInfoActive: boolean,
): TivoPayloadAction<{ isStandardInfoActive: boolean }> => ({
    type: SET_IS_STANDARD_INFO_ACTIVE,
    payload: { isStandardInfoActive },
});

export const setIsFullInfoActive = (
    isFullInfoActive: boolean,
): TivoPayloadAction<{ isFullInfoActive: boolean }> => ({
    type: SET_IS_FULL_INFO_ACTIVE,
    payload: { isFullInfoActive },
});

export const setIsTrickplayMenuActive = (
    isTrickplayMenuActive: boolean,
): TivoPayloadAction<{ isTrickplayMenuActive: boolean }> => ({
    type: SET_IS_TRICKPLAY_MENU_ACTIVE,
    payload: { isTrickplayMenuActive },
});

export const setActivePositionsAction = (
    activePositionsAvailable: Map<MediaButtonTypes, MediaButtonState>,
): TivoPayloadAction<{ activePositionsAvailable: Map<MediaButtonTypes, MediaButtonState> }> => ({
    type: SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE,
    payload: {
        activePositionsAvailable,
    },
});

export const setCurrentActiveIndexAction = (
    currentActiveIndex: number,
): TivoPayloadAction<{ currentActiveIndex: number }> => ({
    type: SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX,
    payload: {
        currentActiveIndex,
    },
});

export const updateStandardInfoTimeoutIdAction = (
    standardInfoTimeoutId: any,
): TivoPayloadAction<{ standardInfoTimeoutId: any }> => ({
    type: UPDATE_STANDARD_INFO_TIMER,
    payload: {
        standardInfoTimeoutId,
    },
});

export const updateFullInfoTimeoutIdAction = (
    fullInfoTimeoutId: any,
): TivoPayloadAction<{ fullInfoTimeoutId: any }> => ({
    type: UPDATE_FULL_INFO_TIMER,
    payload: {
        fullInfoTimeoutId,
    },
});

export const updateTrickPlayBarTimeoutIdAction = (
    trickPlayBarTimeoutId: any,
): TivoPayloadAction<{ trickPlayBarTimeoutId: any }> => ({
    type: UPDATE_TRICKPLAY_TIMER,
    payload: {
        trickPlayBarTimeoutId,
    },
});

export const updateActionStripReferenceAction = (
    actionStripReference: React.RefObject<HTMLDivElement> | null,
): TivoPayloadAction<{ actionStripReference: React.RefObject<HTMLDivElement> | null }> => ({
    type: UPDATE_ACTION_STRIP_REFERECE,
    payload: {
        actionStripReference,
    },
});

export const setEnteringChannelNumberEnabledAction = (
    enteringChannelNumberEnabled: boolean,
): TivoPayloadAction<{ enteringChannelNumberEnabled: boolean }> => ({
    type: SET_ENTERTING_CHANNEL_NUMBER_ENABLED,
    payload: {
        enteringChannelNumberEnabled,
    },
});

export const setEnteredChannelNumberAction = (
    channelNumberEntered: string,
): TivoPayloadAction<{ channelNumberEntered: string }> => ({
    type: SET_ENTERED_CHANNEL_NUMBER,
    payload: {
        channelNumberEntered,
    },
});

export const updateEnteringChannelNumberTimeoutIdAction = (
    enteringChannelNumberTimeoutId: any,
): TivoPayloadAction<{ enteringChannelNumberTimeoutId: any }> => ({
    type: UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER,
    payload: {
        enteringChannelNumberTimeoutId,
    },
});

export const updateTrickPlayBarLongKeyPressIntervalIdAction = (
    trickPlayBarLongKeyPressIntervalId: any,
): TivoPayloadAction<{ trickPlayBarLongKeyPressIntervalId: any }> => ({
    type: UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID,
    payload: {
        trickPlayBarLongKeyPressIntervalId,
    },
});

export const setMediaButtonMouseOverIndex = (
    mediaButtonMouseOverIndex: number,
): TivoPayloadAction<{ mediaButtonMouseOverIndex: number }> => ({
    type: SET_MEDIA_BUTTON_MOUSE_OVER_INDEX,
    payload: {
        mediaButtonMouseOverIndex,
    },
});
